import { Component, OnInit } from '@angular/core';
import {DropdownModel} from '../../../../../../models/component/dropdown.model';
import {SessionActivityModel} from '../../../../../../models/student/session.model';
import {DateTime} from 'luxon';
import {AdminSchoolService} from '../../../../../../services/admin/admin-school.service';
import {IStudentActivity} from '../../../../../../models/student/activity.model';
import {ActivatedRoute, Params} from '@angular/router';
import {StringExtensionModel} from '../../../../../../models/extensions/string-extension.model';
import {CsvExportService} from '../../../../../../services/reusable/csv-export.service';
import {
  EvoGroupActivityChartComponent
} from '../../../../../../shared/reusable-controls/evo-group-activity-chart/evo-group-activity-chart.component';

@Component({
  selector: 'app-evo-admin-school-group-activity',
  templateUrl: './evo-admin-school-group-activity.component.html',
  styleUrls: ['./evo-admin-school-group-activity.component.css']
})
export class EvoAdminSchoolGroupActivityComponent implements OnInit {

  Intervals = SessionActivityModel.SessionIntervals;

  dropdownIntervals = [
    new DropdownModel(this.Intervals.Day, 'Day'),
    new DropdownModel(this.Intervals.Week, 'Week'),
    new DropdownModel(this.Intervals.Month, 'Month')
  ];

  currentInterval = this.dropdownIntervals[1];

  startDate = new Date();
  endDate = new Date();

  dropdownActivityTypes = [
    new DropdownModel('answers', 'Answers'),
    new DropdownModel('time', 'Time')
  ];
  activityType = 'answers';

  activities: IStudentActivity[] = [];

  groupId: string;
  schoolId: string;

  constructor(private adminSchoolSv: AdminSchoolService,
              private csvExportSv: CsvExportService,
              private route: ActivatedRoute) { }

  ngOnInit() {

    // Default to 10 weeks past
    const start = DateTime.fromJSDate(this.startDate).minus({ weeks: 10 }).set({ weekday: 1 });
    this.startDate = start.toJSDate();
    this.startDate.setHours(0, 0, 0, 0);

    const end = DateTime.fromJSDate(this.endDate).set({ weekday: 7 });
    this.endDate = end.toJSDate();
    this.endDate.setHours(23, 59, 59, 999);

    this.route.parent.params.subscribe((params: Params) => {

      this.groupId = params.groupId;
      this.schoolId = params.schoolId;

      this.onFetchActivities();

    });

  }

  onFetchActivities() {

    if (this.activityType === 'time') {

      this.adminSchoolSv.fetchGroupSessions(this.schoolId, this.groupId, this.currentInterval.key, this.startDate, this.endDate, -1).subscribe((sessionActivities) => {
        this.activities = sessionActivities;
      });

    } else if (this.activityType === 'answers') {
      this.adminSchoolSv.fetchGroupAnswers(this.schoolId, this.groupId, this.currentInterval.key, this.startDate, this.endDate, false).subscribe((answerActivites) => {
        this.activities = answerActivites;
      });
    }

  }

  onDownloadActivity() {

    const headers = { date: 'date', value: 'value', rawValue: 'rawValue' };
    headers['valueType'] = this.activityType;


    const data = [];
    // Get the number of data points based on the dates selected
    const nbDataPoints = EvoGroupActivityChartComponent.getNumDataPoints(this.currentInterval.key, this.startDate, this.endDate);
    for (let i = 0; i < nbDataPoints; i++) {

      let activity: IStudentActivity = null;
      const startDate = DateTime.fromJSDate(this.startDate);

      let date: string = null;
      if (this.currentInterval.key === SessionActivityModel.SessionIntervals.Day) {

        const currentDate = startDate.plus({
          days: i
        });

        activity = this.activities.find((a) => {

          return a._id.year === currentDate.year &&
            a._id.month === currentDate.month &&
            a._id.dayOfMonth === currentDate.day;

        });

        const day = StringExtensionModel.addZero(currentDate.day);
        const month = StringExtensionModel.addZero(currentDate.month);

        date = `${day} / ${month} / ${currentDate.year}`;

      } else if (this.currentInterval.key === SessionActivityModel.SessionIntervals.Week) {

        const currentDate = startDate.plus({
          weeks: i
        });

        activity = this.activities.find((a) => {

          return a._id.year === currentDate.year &&
            a._id.week === currentDate.weekNumber;

        });

        const startOfWeek = currentDate.set({ weekday: 0 });
        const endOfWeek = currentDate.set({ weekday: 6 });

        const startDay = StringExtensionModel.addZero(startOfWeek.day);
        const startMonth = StringExtensionModel.addZero(startOfWeek.month);

        const endDay = StringExtensionModel.addZero(endOfWeek.day);
        const endMonth = StringExtensionModel.addZero(endOfWeek.month);

        date = `${startOfWeek.weekNumber} / ${startOfWeek.year} (${startDay}/${startMonth} - ${endDay}/${endMonth})`;

      } else if (this.currentInterval.key === SessionActivityModel.SessionIntervals.Month) {

        const currentDate = startDate.plus({
          months: i
        });

        activity = this.activities.find((a) => {

          return a._id.year === currentDate.year &&
            a._id.month === currentDate.month;

        });

        date = `${currentDate.month} / ${currentDate.year}`

      }

      if (activity) {

        data.push({
          date: date,
          value: activity.getScaledValue(),
          rawValue: activity.getValue()
        });

      } else {

        data.push({
          date: date,
          value: 0,
          rawValue: 0,
        });

      }

    }

    this.csvExportSv.downloadFile(data, `activity-${this.activityType}-${this.startDate.toDateString()}-${this.endDate.toDateString()}`);

  }

}
